import { Flex } from "@redotech/arbiter/flex";
import { Header, Text } from "@redotech/arbiter/text";
import Logo from "@redotech/redo-web/logo.svg";
import { memo, type ReactNode } from "react";

import * as css from "./login.module.css";

/** The logo and centered card shared by the login and verify pages. */
export const AuthLayout = memo(function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: ReactNode;
  children?: ReactNode;
}) {
  return (
    <Flex bgColor="primary" className={css.container} dir="column" w="full">
      <Flex pt="3xl" px="3xl">
        <a
          className={css.logoLockup}
          href="https://www.redo.com"
          rel="noreferrer"
          target="_blank"
        >
          <Logo className={css.logo} />
          <Text as="span" fontSize="lg" m="none" textColor="primary">
            Partners
          </Text>
        </a>
      </Flex>
      <Flex
        align="center"
        className={css.formWrapper}
        grow={1}
        justify="center"
        pb="6xl"
      >
        <Flex
          as="section"
          className={css.formArea}
          dir="column"
          gap="3xl"
          w="full"
        >
          <Flex align="center" dir="column" gap="xs">
            <Header
              as="h1"
              fontSize="xxs"
              fontWeight="semibold"
              m="none"
              textAlign="center"
            >
              {title}
            </Header>
            <Text
              fontSize="sm"
              m="none"
              textAlign="center"
              textColor="tertiary"
            >
              {subtitle}
            </Text>
          </Flex>
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
});
